/**
 * O cabeçalho do arquivo, portado de knowledge.js:86-107.
 *
 * São as cinco perguntas que alguém faz antes de mexer num arquivo: quem
 * responde por ele, se a doc está no commit indexado, quanta memória humana
 * existe, quais decisões o governam e se tem proposta esperando revisão. Dono
 * "não declarado" aparece em amarelo de propósito: é uma falta, não um detalhe.
 */
import { useNavigate } from 'react-router-dom';
import { useContagemDeNotas, useDecisoes, useDonos, usePropostas, useSaude } from '../api/consultas';
import { acionavel } from '../componentes/acionavel';
import { donoDe } from '../grafo/nucleo';

const curto = (s?: string | null) => String(s || '').slice(0, 8);

export function CabecaDoArquivo({ slug, chave, docSha, aoPropor }: {
  slug: string;
  chave: string;
  docSha?: string | null;
  aoPropor: () => void;
}) {
  const navegar = useNavigate();
  const donos = useDonos(slug);
  const decisoes = useDecisoes(slug);
  const notas = useContagemDeNotas(slug);
  const propostas = usePropostas(slug);
  const saude = useSaude(slug);

  // unidade especial (overview, guia do agente) não é arquivo e não tem dono
  if (chave.startsWith('__')) return null;

  const dono = donoDe(donos.data || [], chave);
  const decs = (decisoes.data || []).filter((d) => (d.links || []).includes(chave));
  const cabeca = saude.data?.head;
  const atrasada = !!cabeca && !!docSha && docSha !== cabeca;
  const quantasNotas = notas.data?.[chave] || 0;
  const pendentes = (propostas.data?.proposals || [])
    .filter((p) => p.unit_key === chave && p.status === 'pending').length;

  return (
    <div className="file-head" data-fh={chave}>
      <span className="fh">
        <b>dono</b>
        {dono
          ? <code>{dono}</code>
          : <code style={{ color: 'var(--warn)' }}>não declarado</code>}
      </span>
      <span className="fh">
        <b>frescor</b>
        <code style={atrasada ? { color: 'var(--warn)' } : undefined}>
          @{curto(docSha)}{atrasada ? ` · acervo @${curto(cabeca)}` : ' · em dia'}
        </code>
      </span>
      <span className="fh"><b>notas</b><code>{quantasNotas}</code></span>
      {!!decs.length && (
        <span className="fh">
          <b>decisões</b>
          {decs.slice(0, 3).map((d) => (
            <code
              key={d.unit_key}
              className="lnk"
              title={d.title}
              style={{ cursor: 'pointer', color: 'var(--violet)' }}
              {...acionavel(() => navegar(`/p/${slug}/doc?key=${encodeURIComponent(d.unit_key)}`))}
            >
              {d.title}
            </code>
          ))}
        </span>
      )}
      {!!pendentes && (
        <span className="fh">
          <b>revisão</b>
          <code style={{ color: 'var(--warn)' }}>{pendentes} proposta(s) pendente(s)</code>
        </span>
      )}
      <button
        type="button"
        className="btn ghost sm"
        onClick={() => navegar(`/p/${slug}/impact?key=${encodeURIComponent(chave)}`)}
      >
        ver impacto
      </button>
      <button type="button" className="btn ghost sm" onClick={aoPropor}>propor correção</button>
    </div>
  );
}
